export const COMMAND_NEW_POLL = 'new-poll';
export const COMMAND_ANSWER_POLL = 'answer-poll';
export const COMMAND_OLD_POLLS = 'old-polls';
export const COMMAND_START_POLLS = 'start-poll';
export const COMMAND_ADD_OPTION_POLL = 'add-option-poll';
export const COMMAND_END_POLL = 'end-poll';
export const COMMAND_DELETE_POLL = 'delete-poll';
export const COMMAND_REOPEN_POLL = 'reopen-poll';
export const COMMAND_UPDATE_POLL = 'update-poll';
export const CHAR_LIMIT = 1000;
export const ANSWERS_LIMIT = 255;
